import { render, staticRenderFns } from "./smtForm.vue?vue&type=template&id=3d872dfc&scoped=true"
import script from "./smtForm.vue?vue&type=script&lang=js"
export * from "./smtForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d872dfc",
  null
  
)

export default component.exports